export const DEVICE_NAVIGATION_CLICK = 'DEVICE_NAVIGATION_CLICK';
export const TOGGLE_ACCOUNT_MENU = 'toggleAccountMenu';
export const appName = 'Grover';
export const AUTH_TOKEN_COOKIE = 'AUTH_TOKEN_COOKIE';
